import { Filter, FilterOption, FilterType } from '../../../types/types';

export const getSelectedOptionsFromList = (list: FilterOption[]) =>
  list.filter((option) => option.selected);

export function countSelectedFilterOptions(filters: Filter[]): number {
  return filters.reduce((acc, filter) => {
    return acc + getSelectedOptionsFromList(filter.options).length;
  }, 0);
}

export const getUpdatedFilters = (
  filters: Filter[],
  type: FilterType,
  toggledOption: FilterOption,
): Filter[] =>
  filters.map((filter) =>
    filter.type === type
      ? {
          ...filter,
          options: updateOptions(filter.options, toggledOption),
        }
      : filter,
  );

const updateOptions = (
  options: FilterOption[],
  toggled: FilterOption,
  shouldSelectOnlyOne: boolean = false,
): FilterOption[] =>
  options.map((option) => {
    if (option.id === toggled.id) {
      return { ...option, selected: !option.selected };
    }
    return shouldSelectOnlyOne ? { ...option, selected: false } : option;
  });

export const getSelectedFilters = (filters: Filter[]) => {
  const selectedFilters: Filter[] = [];
  filters.forEach((filter) => {
    const selectedOptions = filter.options.filter((option) => option.selected);
    if (selectedOptions.length) {
      selectedFilters.push({
        ...filter,
        options: selectedOptions,
      });
    }
  });
  return selectedFilters;
};

export const isSameFiltersSelected = (
  filters1: Filter[],
  filters2: Filter[],
): boolean => {
  const map1 = createSelectedMap(filters1);
  const map2 = createSelectedMap(filters2);

  return JSON.stringify(map1) === JSON.stringify(map2);
};

const createSelectedMap = (filters: Filter[]): Record<string, string[]> => {
  const map: Record<string, string[]> = {};

  filters.forEach((filter) => {
    const selectedIds = getSelectedOptionsFromList(filter.options)
      .map((option) => option.id)
      .sort();

    if (selectedIds.length) {
      map[filter.type] = selectedIds;
    }
  });

  return map;
};

export const hasSelectedFilters = (filters: Filter[]) =>
  filters.some((filter) => filter.options.some((option) => option.selected));
